export default __webpack_public_path__ + "static/media/win_hand.9e6127dd.mp3";